export class Routine {
    constructor(
        id=-1,
        exercise='',
        reps=-1,
        coefficient=0.0,
        weight=0,
    ) {
        this.id = id;
        this.exercise = exercise;
        this.reps = reps;
        this.coefficient = coefficient;
        this.calculatedReps = reps;
        this.weight = weight;
    }

    getExercise() {
        return this.exercise;
    }

    getReps() {
        return this.reps;
    }

    getCoefficient() {
        return this.coefficient;
    }

    getWeight() {
        return this.weight;
    }
}